// Api End Point
export const URL = 'spatial/'

// State Configuration
export const MODEL = 'Shapes'

// Model Properties
export const PROP_SHAPE_DATA = 'shapeData'
export const PROP_SHAPE_ID = 'id'
export const PROP_ASSET = 'asset'

// Shape data properties
export const PROP_FEATURES = 'features'
